import React, { useEffect, useState } from "react";
import http from "../lib/http";
import { FaStar, FaCommentDots } from "react-icons/fa";
import SEO from "../components/SEO/SEO";

export default function DealerReviewsPage() {

  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadReviews();
  }, []);

  const loadReviews = async () => {

    try {

      const dealer =
        JSON.parse(localStorage.getItem("dealer"));

      const res =
        await http.get(
          `/api/dealers/dealer-reviews/${dealer._id}`
        );

      setReviews(res.data || []);

    } catch (err) {

      console.error("Failed to load reviews", err);

    } finally {

      setLoading(false);

    }
  };

  const averageRating =
    reviews.length > 0
      ? (
          reviews.reduce(
            (sum, review) => sum + review.rating,
            0
          ) / reviews.length
        ).toFixed(1)
      : 0;

  if (loading) {
    return (
      <div className="card-modern">
        <h5>Loading reviews...</h5>
      </div>
    );
  }

  return (
        <>
        <SEO
          title={`Reviews | BuildNear`}
          description={`Read genuine customer reviews for dealer.`}
          url={`https://buildnear.in/dealers/reviews`}
    />
    <div>

      {/* Header */}

      <div className="page-header mb-4">

        <h2 className="fw-bold">
          Customer Reviews
        </h2>

        <p className="text-muted mb-0">
          Manage and monitor customer feedback
        </p>

      </div>

      {/* Summary Cards */}

      <div className="dashboard-grid mb-4">

        <div className="stat-card">

          <div className="stat-icon">
            <FaCommentDots />
          </div>

          <div>
            <h3>{reviews.length}</h3>
            <span>Total Reviews</span>
          </div>

        </div>

        <div className="stat-card">

          <div className="stat-icon">
            <FaStar />
          </div>

          <div>
            <h3>{averageRating}</h3>
            <span>Average Rating</span>
          </div>

        </div>

      </div>

      {/* Reviews */}

      {reviews.length === 0 ? (

        <div className="card-modern text-center">

          <h5>No Reviews Yet</h5>

          <p className="text-muted mb-0">
            Customer reviews will appear here once approved.
          </p>

        </div>

      ) : (

        <div className="reviews-grid">

          {reviews.map((review) => (

            <div
              className="review-card"
              key={review._id}
            >

              <div className="d-flex justify-content-between align-items-start mb-2">

                <div>

                  <h6 className="mb-1">
                    {review.name}
                  </h6>

                  <small className="text-muted">

                    {new Date(
                      review.createdAt
                    ).toLocaleDateString()}

                  </small>

                </div>

              </div>

              <div className="mb-3">

                {[1, 2, 3, 4, 5].map((i) => (

                  <FaStar
                    key={i}
                    color={
                      i <= review.rating
                        ? "#f59e0b"
                        : "#d1d5db"
                    }
                    size={18}
                    className="me-1"
                  />

                ))}

              </div>

              <p className="mb-0 text-muted">
                {review.comment}
              </p>

            </div>

          ))}

        </div>

      )}

    </div>
    </>
  );
}